import React from "react";
import ClipTitle from "./ClipTitle";
import { useTranslation } from 'react-i18next';

export default function PlayList(props){
    const { t } = useTranslation();

    let gameInfoId = null;
    let batterId = null;
    let pitcherId = null;
    let inning = null;
    let batInningTurn = null;

    //미리 playList를 한번 반복문을 돌려서 만약 투수, 타자. 이닝, 배팅 순서 중 하나라도 다르면 각 값을 새로 변수에 넣어주고 titleYn에 "Y"를 저장
    //타이틀을 출력 여부를 저장 
    props.playList.forEach(function(item){
        if((gameInfoId == null || item.gameInfoId != gameInfoId) || (batterId == null || item.batterMembersId != batterId) || (pitcherId == null || item.pitcherMembersId != pitcherId) || (inning == null || item.inning != inning) || (batInningTurn == null || item.batInningTurn != batInningTurn)){
            gameInfoId = item.gameInfoId;
            batterId = item.batterMembersId;
            pitcherId = item.pitcherMembersId;
            inning = item.inning;
            batInningTurn = item.batInningTurn;

            item.titleYn = "Y";
        }
    });

    if(props.playList.length > 0){
        if(props.content == "hitCourse"){
            return(
                <React.Fragment>
                    {/* {props.playList.map((playInfo) => ( */}
                        <div key={props.playList[0].gameRecordId+"_"+props.playList[0]['localPath']} onClick={props.selectClipEventHandler} className='clip_list' name="videoClips" 
                        rel={props.playList[0].gameInfoId + props.playList[0].gameRecordId + props.playList[0].inning + props.playList[0].inningTb + props.playList[0].batInningTurn + props.playList[0].batPitchSeq}>
                            <table id="clipTitleTable" style={{width:"100%"}}>
                                <tbody>
                                    {/* 만약 던진 공이 해당 타석의 첫번째 공이라면 타이틀 출력 */}
                                    {(props.playList[0].titleYn == "Y") ? <ClipTitle playInfo={props.playList[0]} useLang={props.useLang} cookie={props.cookie}/> : null}
                                </tbody>
                            </table>
                            <table id="clipDetailTable" style={{width:"100%"}}>
                                <tbody>
                                    <tr style={{textAlign:"center", fontSize:"13px"}}>
                                        <td style={{width:"15%", padding:"8px"}}>{props.playList[0].batPitchSeq}({props.playList[0].pureBatPitchSeq})</td>
                                        <td style={{width:"15%", padding:"8px"}}>{props.playList[0].beforeBallCount}-{props.playList[0].beforeStrikeCount}</td>
                                        <td style={{width:"20%", padding:"8px"}}>{props.useLang === "en" ? props.playList[0].ballTypeShortName : props.playList[0].ballCodeName}</td>
                                        <td style={{width:"20%", padding:"8px"}}>{props.playList[0].ballSpeed}Km/h</td>
                                        <td style={{width:"15%", padding:"8px"}}>{props.useLang === 'en' ? props.playList[0].hitResultShortName : props.playList[0].hitResultName}</td>
                                        {/* (만약 checkBase 값이 있을 경우, 즉 견제를 했을 경우) */}
                                        <td style={{width:"15%", padding:"8px"}}>
                                            {props.playList[0].checkBase == "1" ? t('pick1st') : null}
                                            {props.playList[0].checkBase == "2" ? t('pick2nd') : null}
                                            {props.playList[0].checkBase == "3" ? t('pick3rd') : null}
                                            {props.playList[0].checkBase == "23" ? t('catcherPick1st') : null}
                                            {props.playList[0].checkBase == "24" ? t('catcherPick2nd') : null}
                                            {props.playList[0].checkBase == "25" ? t('catcherPick3rd') : null}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    {/* ))} */}
                </React.Fragment>
            )
        } else {
            return(
                <React.Fragment>
                    {props.playList.map((playInfo) => (
                        <div key={playInfo['gameInfoId']+"_"+playInfo['inningPitchSeq']} onClick={props.selectClipEventHandler} className='clip_list' name="videoClips" 
                        rel={playInfo.gameInfoId + playInfo.gameRecordId + playInfo.inning + playInfo.inningTb + playInfo.batInningTurn + playInfo.batPitchSeq}>
                            <table id="clipTitleTable" style={{width:"100%"}}>
                                <tbody>
                                    {/* 만약 던진 공이 해당 타석의 첫번째 공이라면 타이틀 출력 */}
                                    {(playInfo.titleYn == "Y") ? <ClipTitle playInfo={playInfo} useLang={props.useLang} cookie={props.cookie}/> : null}
                                </tbody>
                            </table>
                            <table id="clipDetailTable" style={{width:"100%"}}>
                                <tbody>
                                    <tr style={{textAlign:"center", fontSize:"13px"}}>
                                        <td style={{width:"15%", padding:"8px"}}>{playInfo.batPitchSeq}({playInfo.pureBatPitchSeq})</td>
                                        <td style={{width:"15%", padding:"8px"}}>{playInfo.beforeBallCount}-{playInfo.beforeStrikeCount}</td>
                                        <td style={{width:"20%", padding:"8px"}}>{props.useLang === "en" ? playInfo.ballTypeShortName : playInfo.ballCodeName}</td>
                                        <td style={{width:"20%", padding:"8px"}}>{playInfo.ballSpeed}Km/h</td>
                                        <td style={{width:"15%", padding:"8px"}}>{props.useLang === 'en' ? playInfo.hitResultShortName : playInfo.hitResultName}</td>
                                        {/* (만약 checkBase 값이 있을 경우, 즉 견제를 했을 경우) */}
                                        <td style={{width:"15%", padding:"8px"}}>
                                            {playInfo.checkBase == "1" ? t('pick1st') : null}
                                            {playInfo.checkBase == "2" ? t('pick2nd') : null}
                                            {playInfo.checkBase == "3" ? t('pick3rd') : null}
                                            {playInfo.checkBase == "23" ? t('catcherPick1st') : null}
                                            {playInfo.checkBase == "24" ? t('catcherPick2nd') : null}
                                            {playInfo.checkBase == "25" ? t('catcherPick3rd') : null}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    ))}
                </React.Fragment>
            )
        }
    } else{
        return null;
    }
}